import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { dataMapping } from './apiDataMapping';
import { UserListButtons } from '../Components/UserList/UserListButtons';
import axios from "axios";
import GameCoverInfo from "../Components/Misc Components/GameCoverInfo";

export const useSearchResults = (details, dataFilter, itemOffset,userData, onUserListDel, onUserListSave, events, onEventSave, onEventDel, listAmount) => {
    const navigate = useNavigate()
    const [pageCount,setPageCount] = useState(1)
    const [currentPageDetails,setCurrentPageDetails] = useState([])
    const [sortedPageDetails,setSortedPageDetails] = useState([])
    const [priceData,setPriceData] = useState([])
    const [reviewData,setReviewData] = useState([])
    const gamePassData = localStorage.getItem("gamePassData") ? JSON.parse(localStorage.getItem("gamePassData")).data : [];
    const [showGameCarousel,setShowGameCarousel] = useState(false);
    const [gameScreenshots,setGameScreenshots] = useState(null);
    const [dealIds, setDealIds] = useState(JSON.parse(localStorage.getItem("dealIds")));
    useEffect(() => {
    localStorage.setItem("dealIds", JSON.stringify(dealIds));
    }, [dealIds]);
    const saveEvent = (title,game,date) => {
        const dateChange = `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
        onEventSave([ ...events, { title: title, game: game, date: dateChange }])
    }
    const delEvent = (title) => { onEventDel(events.filter(e => e.game.name !== title)) }
    const toggleCarousel = (id) => {
        if(id == 0) {
            setShowGameCarousel(false)
        } else {
            let g = details.filter(e => e.id == id)[0];
            setGameScreenshots(g.screenshots ? g.screenshots.map((img, index) => <div key={index}><img src={`//images.igdb.com/igdb/image/upload/t_screenshot_huge/${img.image_id}.jpg`}></img></div>) : null)
            setShowGameCarousel(true)
        }
    }

    useEffect(() => {
        if(details && details[0] !== "No Results Found") {
            axios({
                url: "https://game-cal-cors.onrender.com/https://api.isthereanydeal.com/lookup/id/title/v1?key=76cbea7357be1587159216845c88b8c0a352e93c",
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                },
                    data: details.slice().map((item)=>item.name)
                })
                .then(response => {
                    const tempResp = Object.fromEntries(Object.entries(response.data).filter(([key,value])=> value !== null));
                    const oldData = localStorage.getItem("dealIds") ? JSON.parse(localStorage.getItem("dealIds")) : {};
                    let combinedData = {};
                    let counter = Object.keys(tempResp).length;
                    if(oldData !== "null") combinedData = Object.assign({},oldData, tempResp);
                    else combinedData = tempResp
                    setDealIds(combinedData)
                    if(Object.keys(tempResp).length > 0) {
                        while(counter > 0) {
                            axios({
                                url: "https://game-cal-cors.onrender.com/https://api.isthereanydeal.com/games/prices/v3?key=76cbea7357be1587159216845c88b8c0a352e93c&country=US&deals=false",
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                },
                                    data: Object.values(tempResp).slice(counter-200 > 0 ? counter-200 : 0,counter)
                                })
                            .then(response2 => {
                                response2.data.forEach((item)=> {
                                    item.title = Object.keys(tempResp).find((item2) => tempResp[item2] === item.id)
                                })
                                setPriceData(priceData => [...priceData,...response2.data])
                            })
                            .catch(err => {
                                console.error(err);
                            });
                            counter = counter - 200
                        }
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },[details])

    useEffect(() => {
        const shopData = localStorage.getItem("shopData") ? JSON.parse(localStorage.getItem("shopData")) : [];
        if(priceData.length > 0 && shopData && shopData.favorites.length > 0) {
            priceData.forEach((item) => {
                const sortedPriceData = [];
                const deals = item.deals.filter((item2) => item2.cut > 0)
                const prices = item.deals.filter((item2) => item2.cut === 0)
                shopData.favorites.forEach((item2) => {const check = deals.find((item3) => item3.shop.name === item2); check && sortedPriceData.push(check)})
                deals.forEach((item2) => !sortedPriceData.includes(item2) && sortedPriceData.push(item2))
                shopData.favorites.forEach((item2) => {const check = prices.find((item3) => item3.shop.name === item2); check && sortedPriceData.push(check)})
                prices.forEach((item2) => !sortedPriceData.includes(item2) && sortedPriceData.push(item2))
                item.deals = sortedPriceData
            })
        }
    },[priceData])

    useEffect(() => {
        let endOffset = itemOffset + listAmount;
        let currentDetails = []
        if(details) {
            let sortedDetails = details.slice();
            if (dataFilter) {
                sortedDetails.sort((a,b) => {
                    if (dataFilter === "aggregated_rating" || dataFilter === "first_release_date") {
                        if((a[dataFilter] ? a[dataFilter] : 0) > (b[dataFilter] ? b[dataFilter] : 0)) return -1
                    } else if (dataFilter === "hltbReview") {
                        if((a["userReview"] ? a["userReview"][dataFilter] : 0) > (b["userReview"] ? b["userReview"][dataFilter] : 0)) return -1
                    } else {
                        if((a[dataFilter] ? a[dataFilter] : Number.MAX_VALUE) < (b[dataFilter] ? b[dataFilter] : Number.MAX_VALUE)) return -1
                    }
                })
            } else {
                sortedDetails.sort((a,b) => {if((a["first_release_date"] ? a["first_release_date"] : 0) > (b["first_release_date"] ? b["first_release_date"] : 0)) return -1})
            }
            currentDetails = sortedDetails.slice(itemOffset, endOffset)
            setPageCount(Math.ceil(sortedDetails.length / listAmount))
            const tempReviewData = [];
            currentDetails.forEach((item)=> {
                if(dealIds && dealIds[item.name] && item.first_release_date && new Date(item.first_release_date*1000).getTime() < new Date().getTime()) {
                    axios.get("https://game-cal-cors.onrender.com/https://api.isthereanydeal.com/games/info/v2?key=76cbea7357be1587159216845c88b8c0a352e93c&id="+dealIds[item.name])
                    .then(response => {
                        tempReviewData.push(response.data)
                        if(tempReviewData.length == currentDetails.filter((item2)=>dealIds[item2.name] && item2.first_release_date && new Date(item2.first_release_date*1000).getTime() < new Date().getTime()).length)
                            setReviewData(tempReviewData)
                    })
                    .catch(err => {
                        console.error(err);
                    });
                }
            })
            setSortedPageDetails(currentDetails)
        }
    },[details, itemOffset, listAmount, dealIds])

    useEffect(() => {
        if(details && details[0] === "No Results Found") {setCurrentPageDetails(details); setPageCount(1)}
        setCurrentPageDetails(sortedPageDetails.map((e,index) => {
            const gameModes = dataMapping(e,"game_modes",navigate)
            const gameGenres = dataMapping(e,"genres",navigate)
            const gamePerspectives = dataMapping(e,"player_perspectives",navigate)
            const gamePlatforms = dataMapping(e,"platforms",navigate)
            const gameReleaseDate = e.first_release_date ? new Date(e.first_release_date*1000) : null
            const gameThemes = dataMapping(e,"themes",navigate)
            const gamePassDataFound = gamePassData?.find((game) => game.title.replace(/[^\x00-\x7F]/g, "").toLowerCase().includes(e.name.replace(/[^\x00-\x7F]/g, "").toLowerCase()));
            const currentGameReview = reviewData && reviewData.find((item)=>item.title === e.name);
            const currentGamePrice = priceData && priceData.find((item)=>item.title === e.name);
            const calendarReleaseCheck = events.some(eventGame => eventGame.game && eventGame.game.name === e.name && eventGame.title.includes("Release"));
            if(reviewData)
                e.reviewData = currentGameReview
            if(priceData)
                e.priceData = currentGamePrice
            return(
                <div key={index} className="sResultItem" onMouseEnter={()=>toggleCarousel(e.id)} onMouseLeave={()=>toggleCarousel(0)}>
                    <div style={{display:"grid",gridTemplateColumns:"25% auto 15%",columnGap:"5px",height:"100%"}}>
                        <div>
                            <div className="gameCover" style={{fontSize:"18px",fontWeight:"600"}} onClick={() => navigate("/game-details/"+e.id)}>
                                {e.cover ? <img className="gameCoverImg" src={`//images.igdb.com/igdb/image/upload/t_cover_big/${e.cover.image_id}.jpg`} width="100%" height={currentGamePrice ? "330px" : "285px"} /> : <img className="gameCoverImg" style={{width:"100%"}} src="https://t4.ftcdn.net/jpg/02/51/95/53/360_F_251955356_FAQH0U1y1TZw3ZcdPGybwUkH90a3VAhb.jpg" width="100%" height="275px" />}
                                <div className="gameCoverName">
                                    <GameCoverInfo currentGamePrice={currentGamePrice} gamePassDataFound={gamePassDataFound?.type} />
                                    {e.name}
                                </div>
                            </div>
                            {gameReleaseDate >= new Date() &&
                                <div style={{textAlign:"center",marginTop:"5px"}} >
                                    {!calendarReleaseCheck ?
                                        <button className="btn btn-primary btn-sm" onClick={() => saveEvent(e.name+" Release",e,gameReleaseDate)}>Add to Calendar</button>
                                    :
                                        <button className="btn btn-danger btn-sm" onClick={() => delEvent(e.name)}>Remove from Calendar</button>
                                    }
                                </div>
                            }
                        </div>
                        <div>
                            {currentGamePrice ? <div style={{display:"flex",justifyContent:"space-between",gap:"10px",overflow:"auto",maxWidth:"22vw",fontWeight:"600",borderBottom:"1px solid white"}}>
                                {currentGamePrice.deals.map((item, ind)=>
                                    <div key={ind}>
                                        <div><a style={{cursor:"pointer",color:"rgba(100, 180, 250)",textShadow:"1px 1px 1px black"}} onClick={()=>window.open(item.url, '_blank', 'noopener,noreferrer')}><u>{item.shop.name}</u></a></div>
                                        {item.cut > 0 ? <div>
                                            <div style={{display:"flex",gap:"5px"}}>
                                                <div style={{color:"rgb(190, 238, 17)",textShadow:"1px 1px 1px black"}}>${item.price.amount}</div>
                                                <div style={{backgroundColor:"rgb(76, 107, 34)",borderRadius:"5px",textShadow:"1px 1px 1px black",color:"rgb(190, 238, 17)"}}>{item.cut}% off</div>
                                                <div style={{fontSize:"15px"}}><s>${item.regular.amount}</s></div>
                                            </div>
                                            <div style={{backgroundColor:"rgb(140, 39, 66)",borderRadius:"5px",textShadow:"1px 1px 1px black",color:"rgb(255, 86, 86)"}}>
                                                Expires On {new Date(item.expiry).toLocaleDateString()} 
                                                {!events.some(eventGame => eventGame.game && eventGame.game.name === e.name && eventGame.title.includes(item.shop.name + " Deal")) ? 
                                                    <button className="btn btn-primary btn-sm" style={{fontSize:"12px"}} onClick={() => saveEvent(e.name+" "+item.shop.name+" Deal Expires",e,new Date(item.expiry))}><i className="fa fa-save"/></button>
                                                :
                                                    <button className="btn btn-danger btn-sm" style={{fontSize:"12px"}} onClick={() => delEvent(e.name)}><i className="fa fa-save"/></button>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div>${item.regular.amount}</div>
                                        }
                                    </div>
                                )}
                            </div>
                            :
                            <div style={{fontWeight:"600",borderBottom:"1px solid white"}}>Price Data Not Found</div>
                            }
                            {gameReleaseDate < new Date() && (currentGameReview && currentGameReview.players ?
                                <div style={{display:"flex",justifyContent:"space-between",fontWeight:"600",textAlign:"center",borderBottom:"1px solid white",textShadow:"1px 1px 1px #a760e9"}}>
                                    <div>Current Players<div>{currentGameReview.players.recent}</div></div>
                                    <div>Daily Peak<div>{currentGameReview.players.day}</div></div>
                                    <div>Weekly Peak<div>{currentGameReview.players.week}</div></div>
                                    <div>All Time Peak<div>{currentGameReview.players.peak}</div></div>
                                </div>
                            :
                                <div style={{fontWeight:"600",borderBottom:"1px solid white"}}>Unknown Player<div>Data</div></div>)
                            }
                            <div style={{fontSize:"14px",fontWeight:"600",overflowY:"auto",height:gameReleaseDate > new Date() ? "220px" : "175px"}}>
                                {e.game_status && <div>
                                                        <div style={{fontSize:"16px",textShadow:"1px 1px 1px black"}}><i>Early Access</i></div>
                                                </div>}
                                {gamePlatforms && <div>
                                                    <div style={{fontWeight:"700"}}>Platforms</div>
                                                    <div style={{paddingLeft:"10px"}}>{gamePlatforms}</div>
                                                </div>}
                                {gameReleaseDate && <div>
                                                        <div style={{fontWeight:"700"}}>Release Date</div>
                                                        <div style={{paddingLeft:"10px"}}>{(gameReleaseDate.getUTCMonth()+1) +"/"+gameReleaseDate.getUTCDate()+"/"+gameReleaseDate.getUTCFullYear()}</div>
                                                    </div>}
                                {gameModes && <div>
                                                <div style={{fontWeight:"700"}}>Game Modes</div>
                                                <div style={{paddingLeft:"10px"}}>{gameModes}</div>
                                            </div>}
                                {gameGenres && <div>
                                                <div style={{fontWeight:"700"}}>Genres</div>
                                                <div style={{paddingLeft:"10px"}}>{gameGenres}</div>
                                            </div>}
                                {gamePerspectives && <div>
                                                        <div style={{fontWeight:"700"}}>Player Perspectives</div>
                                                        <div style={{paddingLeft:"10px"}}>{gamePerspectives}</div>
                                                    </div>}
                                {gameThemes && <div>
                                                    <div style={{fontWeight:"700"}}>Themes</div>
                                                    <div style={{paddingLeft:"10px"}}>{gameThemes}</div>
                                                </div>}
                            </div>
                        

                        <div>
                                <UserListButtons 
                                    game={e}
                                    searchBar={false}  
                                    searchResult={true}  
                                    onUserListSave={onUserListSave}
                                    onUserListDel={onUserListDel}
                                    userData={userData}
                                    events={events}
                                    onEventSave={onEventSave}
                                    gamePassData={gamePassDataFound}
                                />
                            </div>
                        </div>
                        <div>
                            {gameReleaseDate < new Date() && <div style={{display:"grid",textAlign:"center"}}>
                                {currentGameReview && currentGameReview.reviews && currentGameReview.reviews.map((item, ind)=>
                                    <div key={ind} style={{textShadow:"1px 1px 1px #a760e9"}}>
                                        <div><a style={{cursor:"pointer",color:"rgba(100, 180, 250)",textShadow:"1px 1px 1px black"}} onClick={()=>window.open(item.url, '_blank', 'noopener,noreferrer')}><u>{item.source}</u></a></div>
                                        <div>{item.score}%</div>
                                        <div>{item.count} Reviews</div>
                                    </div>
                                )}
                                
                            </div>}
                            
                        </div>
                    </div>
                </div>
            )
        }))
    }, [details, dataFilter, events, userData, sortedPageDetails, priceData, reviewData])

    return {
        currentPageDetails, 
        pageCount,
        gameScreenshots,
        showGameCarousel
    };
};